define('webshopFiltersDetailView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'buttonView',
  'modalView',
  'modalsAlertView',
  'modalsConfirmationView',
  'webshopFiltersEditView',
  'webshopFiltersProductsView',
  'entities/webshop/filters',
  'template!webshopFiltersDetailView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  ButtonView,
  ModalView,
  AlertView,
  ConfirmationView,
  EditView,
  ProductsView,
  FiltersApi,
  Tpl
) {
  'use strict';

  // Right pane: one filter with its values. options: filterId, languages, groups,
  // onChanged() (list counts / names to refresh), onDeleted().
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-filters-detail-view',

    regions: {
      editRegion: '.edit-region',
      deleteRegion: '.delete-region',
      addValueRegion: '.add-value-region'
    },

    events: {
      'click .value .edit': 'onEditValue',
      'click .value .delete': 'onDeleteValue',
      'click .value .products': 'onShowProducts'
    },

    initialize: function () {
      this.filter = null;
      this.loading = true;
      this.fetch();
    },

    fetch: function () {
      FiltersApi.get(this.options.filterId).done(_.bind(function (filter) {
        this.filter = filter;
        this.loading = false;
        if (!this.isDestroyed)
          this.render();
      }, this)).fail(_.bind(function (message) {
        this.loading = false;
        this.error = message;
        if (!this.isDestroyed)
          this.render();
      }, this));
    },

    serializeData: function () {
      if (!this.filter)
        return {loading: this.loading, error: this.error || '', filter: null};

      var lang = Settings.get('lang');
      var group = _.findWhere(this.options.groups || [], {id: this.filter.groupId});

      return {
        loading: false,
        error: '',
        filter: {
          id: this.filter.id,
          name: FiltersApi.name(this.filter.names, lang) || '(' + this.filter.id + ')',
          names: this.filter.names,
          code: this.filter.code,
          group: group ? group.label : this.filter.groupId,
          webshop: this.filter.webshop,
          productCount: this.filter.productCount
        },
        values: _.map(_.sortBy(this.filter.values, function (v) {
          return -v.productCount;
        }), function (v) {
          return {
            valueId: v.valueId,
            name: FiltersApi.name(v.names, lang) || '(' + v.valueId + ')',
            otherNames: _.map(_.omit(v.names, lang), function (n, l) { return l + ': ' + n; }).join(' · '),
            code: v.code,
            color: FiltersApi.colorToHex(v.color),
            param: v.param,
            webshop: v.webshop,
            productCount: v.productCount
          };
        })
      };
    },

    onRender: function () {
      if (!this.filter)
        return;

      this.editButton = new ButtonView({type: 'edit', text: _.i18n('common.edit', null, 'Edit')});
      this.editButton.on('click', _.bind(this.onEdit, this));
      this.getRegion('editRegion').show(this.editButton);

      this.deleteButton = new ButtonView({type: 'remove', text: _.i18n('common.delete', null, 'Delete')});
      this.deleteButton.on('click', _.bind(this.onDelete, this));
      this.getRegion('deleteRegion').show(this.deleteButton);

      this.addValueButton = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('webshop.filters.addValue', null, 'New value')
      });
      this.addValueButton.on('click', _.bind(this.onAddValue, this));
      this.getRegion('addValueRegion').show(this.addValueButton);
    },

    isBrand: function () {
      return this.filter && this.filter.names && this.filter.names.en === 'Brand';
    },

    getValue: function (e) {
      var valueId = parseInt($(e.currentTarget).closest('.value').data('id'), 10);
      return _.findWhere(this.filter.values, {valueId: valueId});
    },

    reload: function () {
      this.fetch();
      if (this.options.onChanged)
        this.options.onChanged();
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    },

    //----------------
    // Filter

    onEdit: function () {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'filter',
        brandWarning: this.isBrand(),
        languages: this.options.languages,
        groups: this.options.groups,
        model: new Backbone.Model({
          names: this.filter.names,
          code: this.filter.code,
          groupId: this.filter.groupId
        }),
        title: _.i18n('webshop.filters.editFilter', null, 'Edit filter'),
        confirmButtonText: _.i18n('common.save', null, 'Save'),
        onConfirm: _.bind(function (model) {
          FiltersApi.update({
            id: this.filter.id,
            names: model.get('names'),
            code: model.get('code'),
            groupId: model.get('groupId')
          }).done(_.bind(this.reload, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    onDelete: function () {
      var text = _.i18n('webshop.filters.deleteConfirm', null,
        'Delete this filter, its values and its links to %s products?').replace('%s', this.filter.productCount);
      if (!this.filter.webshop)
        text += ' ' + _.i18n('webshop.filters.pimDeleteWarning', null,
          'It comes from the PIM: the next sync of its products will create it again.');

      ConfirmationView.prototype.open({
        text: text,
        onConfirm: _.bind(function () {
          FiltersApi.remove(this.filter.id).done(_.bind(function () {
            if (this.options.onDeleted)
              this.options.onDeleted();
          }, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    //----------------
    // Values

    openValueEditor: function (title, value, onConfirm) {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'value',
        brandWarning: false,
        languages: this.options.languages,
        model: new Backbone.Model({
          names: value ? value.names : {},
          code: value ? value.code : '',
          color: value ? value.color : -1,
          param: value ? value.param : ''
        }),
        title: title,
        confirmButtonText: _.i18n('common.save', null, 'Save'),
        onConfirm: onConfirm
      });
    },

    onAddValue: function () {
      this.openValueEditor(_.i18n('webshop.filters.addValue', null, 'New value'), null, _.bind(function (model) {
        FiltersApi.addValue({
          filterId: this.filter.id,
          names: model.get('names'),
          code: model.get('code'),
          color: model.get('color'),
          param: model.get('param')
        }).done(_.bind(this.reload, this)).fail(_.bind(this.showError, this));
      }, this));
    },

    onEditValue: function (e) {
      var value = this.getValue(e);
      this.openValueEditor(_.i18n('webshop.filters.editValue', null, 'Edit value'), value, _.bind(function (model) {
        FiltersApi.updateValue({
          filterId: this.filter.id,
          valueId: value.valueId,
          names: model.get('names'),
          code: model.get('code'),
          color: model.get('color'),
          param: model.get('param')
        }).done(_.bind(this.reload, this)).fail(_.bind(this.showError, this));
      }, this));
    },

    onDeleteValue: function (e) {
      var value = this.getValue(e);

      ConfirmationView.prototype.open({
        text: _.i18n('webshop.filters.deleteValueConfirm', null,
          'Delete the value "%s" and its links to %d products?')
          .replace('%s', FiltersApi.name(value.names)).replace('%d', value.productCount),
        onConfirm: _.bind(function () {
          FiltersApi.removeValue(this.filter.id, value.valueId)
            .done(_.bind(this.reload, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    onShowProducts: function (e) {
      var value = this.getValue(e);

      ProductsView.prototype.open({
        filter: this.filter,
        value: value,
        onChanged: _.bind(this.reload, this)
      });
    }
  });
});

